import React, { useEffect, useState } from "react";
import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import "../Pages/Style/billsinvoice.css";
import SideBar from "../Components/SideBar/SideBar";
import TextLinkExample from "../Components/NavBar/NavBar";
import { useContext } from "react";
import { SidebarContext } from "../../context/SidebarContext";
import LogoutCard from "../Components/Card/LogoutCard";
import Footer from "../Components/Footer/Footer";
import { pdfUrl, rmbaseUrl } from "../../Constant/Matcher";
import { Feedback } from "../Pages/Feedback";
import axios from "axios";
import { useCpDetailQuery } from "../../redux/API/RM/CPDetailApi";
import { formatDate } from "../../Constant/utils";
import { Link } from "react-router-dom";
import { FaXmark } from "react-icons/fa6";

const RMBillInvoice = () => {
    const { isSiderbaropen } = useContext(SidebarContext);
    const [showLogout, setShowLogout] = useState(false);
    const [searchQuery, setSearchQuery] = useState("")
     const [tableData, setTableData] = useState("");
     const [showTableModal, setShowTableModal] = useState(false);
    const userData = JSON.parse(localStorage.getItem("userData"));
   const rmId = userData?.validateEmail && userData?.validateEmail[0]?._id;
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    let dueDate = 45;
  const {data: cpList} = useCpDetailQuery(rmId)
  useEffect(() => {
    const getData = () => {
      let base = `billing?rmid=${rmId}`
      if(searchQuery) base = `billing?rmid=${rmId}&cpid=${searchQuery}`
      axios.get(`${rmbaseUrl}${base}`).then((res) => {
        setData(res?.data)
        setIsLoading(false)
      })
    }
    getData()
  },[rmId, searchQuery])
  
  
  const pendingBillsAmount = data?.clients?.reduce((acc, result) => {
    const billingAmount = result?.billingamount || 0;
    const discount = result?.discount || 0;
  
    const totalAmount = ((billingAmount - discount) * 0.18) + billingAmount;
  
    const totalPending = result?.lastpayment?.reduce((sum, payment) => {
      return sum + (payment?.amountpaid || 0);
    }, 0);
  
    return acc + (totalAmount - totalPending);
  }, 0);
  
  const countPartiallyPaid = data?.clients?.reduce((acc, result) => {
    const totalRevenue = result?.lastpayment?.reduce((sum, payment) => {
      return payment?.cppaidstatus === "paid" 
        ? sum + (payment?.cpcaculation || 0) 
        : sum;
    }, 0);
  
    return acc + totalRevenue;
  }, 0);
  
    
const handleTableData = (item) => {
  setTableData(item)
  setShowTableModal(true)
}



  return (
    <>
    <div className="App">
        <SideBar />
        <div className={!isSiderbaropen ? "pages" : "pages-change"}>
          <TextLinkExample setShowLogout={setShowLogout} />
          <div className=" BillsInvoice  min-vh-100 ">
            <div className="BillsInvoiceHeader py-2 mx-4 my-4">
              <div className="card">
                <div className="d-flex">
              <div className="Pending">
                  <span className="pendingTitle mx-2">
                  Total Clients:
                  </span>
                  <span className="pendingNumber mx-2">
                    {data?.clients?.length}
                  </span>
                </div>
                <div className="Pending">
                  <span className="pendingTitle mx-2">
                  Total Channels:
                  </span>
                  <span className="pendingNumber mx-2">
                    {cpList?.cpdetail?.length}
                  </span>
                </div>
                </div>
                <div className="d-flex">
                <div className="Pending">
                  <span className="pendingTitle mx-2">
                    Pending Bill Amount:
                  </span>
                  <span className="pendingNumber mx-2">
                    {pendingBillsAmount}
                  </span>
                </div>
                <div className="Pending">
                  <span className="pendingTitle mx-2">Franchise Revenue:</span>
                  <span className="pendingNumber mx-2">
                    {countPartiallyPaid}
                  </span>
                </div>
                </div>
               
              </div>
              <div className="button">
                <button type="submit" className="btn my-2">
                  <i className="fa-solid fa-clock-rotate-left fa-spin fa-spin-reverse mx-2"></i>
                  History
                </button>
              </div>
            </div>
            <div className="BillsInvoiceTable mx-4 overflow-y-hidden ">
            <div className='mx-4 d-flex justify-content-end mb-4'>
              <select name="" id="" className='px-4 py-1 border-black-50 border border-black-50'
              onChange={(e) => setSearchQuery(e.target.value)} value={searchQuery}
              >
                <option value="">Select Channel Partner</option>
                {
            cpList &&  cpList?.cpdetail?.map((i) => (
              <option value={i?.cpinfo?._id} key={i?.cpinfo?._id}>{i?.cpinfo?.name}</option>
            ))
            }
              </select>
            </div>
              <MDBTable
                hover
                striped
                style={{
                  backgroundColor: "RGB(255 255 255)",
                  fontSize: "12px",
                }}
              >
                <MDBTableHead
                  style={{ backgroundColor: "#5A4344", color: "white" }}
                >
                  <tr>
                    <th scope="col">Client Name</th>
                    <th scope="col">Invoice Number</th>
                    <th scope="col">Due Date</th>
                    <th scope="col">Bills Amount</th>
                    <th scope="col">Pending Amount</th>
                    <th scope="col">Paid Amount</th>
                    <th scope="col">Payment Remark</th>
                    <th scope="col">Channel Share</th>
                    <th scope="col">Channel Revenue</th>
                    <th scope="col">Payout Date</th>
                    <th scope="col">Payout Remark</th>
                    <th scope="col">Download</th>
                  </tr>
                </MDBTableHead>
                {isLoading ? (
                    <MDBTableBody>
                      <tr>
                        <td className="text-center" colSpan={9}>
                          Loading...
                        </td>
                      </tr>
                    </MDBTableBody>
                  ) : (
                <MDBTableBody>
                  {data &&
                    data?.clients?.map((i) => {
                      const  clientpendingBillsAmount = i?.lastpayment?.reduce((acc, result) => {
                        const bills = result?.amountpaid;
                        return acc + (bills ? bills : 0);
                      }, 0)
                    const  cprevenuue = i?.lastpayment?.reduce((acc, result) => {
                        const bills = result?.cppaidstatus === "paid" && result?.cpcaculation;
                        return acc + (bills ? bills : 0);
                      }, 0)
                      const payoutData = i?.lastpayment?.filter((item) => (
                        item?.cppaidstatus === "paid" && item?.cppaymentdate
                      ))
                      return (
                      <tr key={i?._id}>
                        <td>{i?.user?.name}</td>
                        <td>{i?.invoiceid}</td>
                       
                        <td>
                        {(() => {
                            const billingDate = new Date(i?.billingdate);
                            billingDate.setDate(
                              billingDate.getDate() + dueDate
                            );

                            const formattedDate = `${String(
                              billingDate.getDate()
                            ).padStart(2, "0")}-${String(
                              billingDate.getMonth() + 1
                            ).padStart(2, "0")}-${billingDate.getFullYear()}`;

                            return formattedDate;
                          })()}
                        </td>
                        <td>{((i?.billingamount - i?.discount)*0.18) + i?.billingamount}</td>
                        <td>{(((i?.billingamount - i?.discount)*0.18) + i?.billingamount) - clientpendingBillsAmount}</td>
                        <td>
                        {clientpendingBillsAmount}
                        </td>
                        <td>{i?.remark}</td>
                        <td>{i?.clientdetail[0]?.cpcommission}%</td>
                        <td>{cprevenuue}</td>
                       <td>{payoutData[0]?.cppaymentdate ? formatDate(payoutData[0]?.cppaymentdate) : `00-00-00`}</td>
                     <td>{payoutData[0]?.cpremark} <br />
                                             {
                                               payoutData[0]?.cpremark && 
                                                 <Link className="text-primary text-decoration-underline"
                                                 onClick={() => handleTableData(i?.lastpayment)}
                                                 >View</Link>
                                             }
                     
                                             </td>
                        <td className="DownloadIcon">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={`${pdfUrl}${i?.billpdf}`}
                          >
                            <span>Invoice</span>
                            <i className="fa-solid fa-file-arrow-down fa-lg mx-4"></i>{" "}
                          </a>
                        </td>
                      </tr>
)})}
                </MDBTableBody>
                  )}
                   {!isLoading && (data?.billingdetail?.length === 0) && (
                          <MDBTableBody>
                            <tr>
                              <td className="text-center" colSpan={9}>No Record found</td>
                            </tr>
                          </MDBTableBody>
                        )}
              </MDBTable>
            </div>
          </div>
          <Footer />
        </div>
        <Feedback />
      </div>
      {showLogout && <LogoutCard setShowLogout={setShowLogout} />}
       {
              showTableModal && 
            <div className="modal-wrapper">
              <div className="bg-white rounded-2 p-3 position-relative">
               <div className="d-flex justify-content-between align-items-center">
                <h5 className="mb-3">Transaction Details</h5>
               <Link className=" mb-3 fs-4" onClick={() => setShowTableModal(false)}><FaXmark /></Link>
               </div>
              <MDBTable
                      hover
                      striped
                      style={{
                        backgroundColor: "RGB(255 255 255)",
                        fontSize: "12px",
                      
                      }}
                    >
                      <MDBTableHead
                        style={{ backgroundColor: "#5A4344", color: "white" }}
                      >
                        <tr>
                          <th scope="col">Payable Amount</th>
                          <th scope="col">Actual Paid Amount</th>
                          <th scope="col">CP Revenue</th>
                          <th scope="col">Payout Date</th>
                          <th scope="col">Payout Remark</th>
                         
                        </tr>
                      </MDBTableHead>
                      <MDBTableBody> 
                        {
                          tableData
                          ?.sort((a,b) => new Date(a?.createdAt) - new Date(b?.createdAt))
                          ?.map((j) => (
                            <tr>
                            <td>{j?.payableamount}</td>
                            <td>{j?.amountpaid}</td>
                            <td>{j?.cpcaculation}</td>
                            <td>{formatDate(j?.cppaymentdate)}</td>
                            <td>{j?.cpremark}</td>
                            </tr>
                          ))
                        }
                       
                       
                      </MDBTableBody>
                      </MDBTable>
              </div>
            </div>
      }
    </>
  )
}

export default RMBillInvoice